// extracted by mini-css-extract-plugin
export var icon = "TrsXx";